import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from '../../uitk-calendar.css';
import { UitkAvailabilityBackgroundAvailabilities } from '../../types.esm.js';

var getClassNameList = classNames.bind(styles);
/**
 * Availability backgrounds indicate availability for an entire day or half days to indicate check-in and check-out limitations.
 * Availability background is used as a background layer within day cells.
 * It should stretch to fill the entire area of its cell, sitting on a layer below all other day template content.
 */
var UitkAvailabilityBackground = function (props) {
    var children = props.children, className = props.className, dataTestId = props.dataTestId, availability = props.availability;
    var wrapperClassNames = getClassNameList('uitk-availability-background', UitkAvailabilityBackgroundAvailabilities.get(availability), className);
    return (React.createElement("div", { className: wrapperClassNames, "data-test-id": dataTestId }, children));
};
UitkAvailabilityBackground.displayName = 'UitkAvailabilityBackground';

export { UitkAvailabilityBackground };
